export enum FeeValueType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE',
}
